import { Client, ClientStatus } from "../../../../index";

const c002Client = new Client({
	id: "c002",
	slug: "version2-companion-extension",
	displayName: "Version2 Companion Extension",
	description:
		"Keep your Version2 account close at hand wherever you work. Sign in securely, open your account, and use supported website integrations.",
	logoUrl:
		"https://storage.googleapis.com/cdn.version2.io/add-ons/c002/icons/c002_icon_rounded.png",
	oauth: {
		authUrl: "https://api.version2.io/v1/oauth/authorize",
		tokenUrl: "https://api.version2.io/v1/oauth/token",
		scopes: ["read", "write", "add-ons:manage"],
		clientId: "plutio-super-extension",
	},
	isDefaultEnabled: true,
	status: ClientStatus.ACTIVE,
});

export default c002Client;
